export default {
  onb: {
    newPartner: 'New supplier',
    newPartnerEyebrow: 'Field onboarding',
    newPartnerDesc: 'Create the supplier cabinet during the visit. Only the name is required; the rest can be filled in later.',
    create: 'Create cabinet',
    creating: 'Creating…',
    created: 'Cabinet created',
    openOnboarding: 'Onboarding',
    eyebrow: 'Supplier onboarding',
    title: 'Onboarding: {{name}}',
    description: 'Cabinet → price list → preview → supplier approval → contract → send to site. Every step is journaled.',
    steps: { cabinet: 'Cabinet', pricelist: 'Price list', preview: 'Preview', approval: 'Approval', contract: 'Contract', send: 'Send to site' },
    back: 'Back to partner',
    save: 'Save',
    saving: 'Saving…',
    saved: 'Saved',
    cancel: 'Cancel',
    required: 'Required',
    sectionCompany: 'Company',
    sectionContacts: 'Contacts',
    sectionWarehouse: 'Warehouse and pickup',
    sectionTerms: 'Commercial terms',
    sectionSite: 'Site listing defaults',
    name: 'Legal name',
    shortName: 'Short name',
    trn: 'TRN (15 digits)',
    address: 'Legal address',
    websiteUrl: 'Website',
    categories: 'Categories (comma separated)',
    contact: 'Owner / contact name',
    role: 'Role',
    phone: 'Phone',
    whatsapp: 'WhatsApp',
    email: 'E-mail',
    city: 'City',
    warehouse: 'Warehouse address (pickup)',
    pickupHours: 'Pickup hours',
    discount: 'Partner discount, %',
    noDiscountOnSpecial: 'No discount on special offers',
    markup: 'B2C markup, % (empty — workspace default)',
    markupB2b: 'B2B markup, % (empty — workspace default)',
    minResaleType: 'Minimum resale rule',
    minResaleValue: 'Minimum resale value',
    minResale: { none: 'None', partner_price: 'Not below partner price', markup_over_cost: 'Markup over cost, %', per_sku: 'Per SKU' },
    reservationPeriodDays: 'Reservation hold, days',
    reservationRespondHours: 'Reservation response, hours',
    poConfirmHours: 'PO confirmation, hours',
    paymentLagDays: 'Payment lag, working days',
    warrantyMonths: 'Warranty, months',
    deliveryDays: 'Delivery days on site (min–max)',
    brandVisible: 'Show partner brand on the site',
    brandVisibleDesc: 'Off by default: the site never names the partner (brief §2.2).',
    statusLabel: 'Status',
    logo: 'Logo',
    uploadLogo: 'Upload logo',
    inviteOwner: 'Invite owner to the portal',
    inviteEmail: 'Owner e-mail',
    inviteName: 'Owner name',
    invite: 'Send invitation',
    invited: 'Invitation sent to {{email}}',
    inviteLink: 'Invitation link (mail is not configured):',
    notes: 'Notes (Treejar only)',
    plUpload: 'Upload price list',
    plUploadDesc: 'PDF, Excel, CSV or page photos go to the AI import. Start it at the beginning of the visit: 40 pages take about 20 minutes.',
    plOpenImport: 'Open import for this supplier',
    plVersions: 'Price list versions',
    plNoVersions: 'No price lists yet.',
    plVersion: 'v{{n}}',
    plItems: '{{count}} items',
    plOpen: 'Open',
    prevTitle: 'How the cards will look on treejartrading.ae',
    prevDesc: 'Names follow the site rule «Type + article + colour», prices are channel prices. Click a card to edit it.',
    supplierMode: 'Supplier view',
    supplierModeDesc: 'Hides purchase prices and markups while the supplier is watching.',
    channel: 'Site for',
    channelB2c: 'buyers (B2C)',
    channelB2b: 'dealers (B2B)',
    filterAll: 'All types',
    sort: { stock: 'In stock (high to low)', priceAsc: 'Price (low to high)', priceDesc: 'Price (high to low)', name: 'Name (A to Z)' },
    products: '{{count}} products',
    price: 'Price: AED {{value}}',
    exclVat: 'excl. VAT',
    inStock: '{{count}} in stock',
    onRequest: 'on request',
    inTransit: '{{count}} in transit',
    addToCart: 'Add to Cart',
    cardAnno: 'Supplier AED {{cost}} · B2C {{b2c}} ({{mB2c}}) · B2B {{b2b}} ({{mB2b}})',
    manual: 'manual',
    rrp: 'RRP',
    cardCost: 'Purchase price',
    cardRrp: 'Supplier RRP',
    cardOurPrice: 'Our site price',
    cardOurPriceB2b: 'Our B2B price',
    cardMargin: 'Margin',
    cardManualHint: 'Manual price; clear the field to return to the markup price ({{value}})',
    cardCalcHint: 'Price by channel markup; type your own — margin recalculates instantly, saved when you leave the field',
    excluded: 'Excluded by supplier',
    noImage: 'No image',
    tabCards: 'Cards',
    tabPrices: 'Prices',
    tabSend: 'Readiness',
    pricesTitle: 'Channel prices, supplier RRP and markups',
    pricesDesc: 'B2C and B2B are computed from the supplier price and the channel markup; type a value to set a manual price (orange), clear it to return to the markup. RRP is the supplier\'s recommended price: it shows the markup the supplier assumes and how far our B2C is from it.',
    colSku: 'SKU',
    colName: 'Name',
    colStock: 'Stock',
    colCost: 'Supplier price',
    colRrp: 'Supplier RRP',
    colRrpMarkup: 'RRP markup',
    colB2c: 'B2C site',
    colB2cMarkup: 'B2C markup',
    colB2cVsRrp: 'B2C vs RRP',
    colB2b: 'B2B dealer',
    colB2bMarkup: 'B2B markup',
    colMargin: 'Margin B2C',
    colStatus: 'Status',
    colProblems: 'Problems',
    totalsRow: 'Stock value ({{count}} SKU)',
    recalc: 'Recalculate by markups',
    recalcDone: '{{count}} prices recalculated',
    editTitle: 'Edit card',
    fType: 'Product type',
    fCategory: 'Site category',
    fCategoryExtra: 'Additional categories',
    fName: 'Name on site',
    fShort: 'Short description',
    fDescription: 'Description',
    fFeatures: 'Feature bullets (one per line)',
    fSpecs: 'Specifications (key: value per line)',
    fGroup: 'Variant group key (colour variants share it)',
    fVariantLabel: 'Variant label',
    fSeoTitle: 'SEO title',
    fSeoDescription: 'SEO description',
    fDelivery: 'Delivery days (min–max)',
    fWarranty: 'Warranty, months',
    fImages: 'Images',
    fAddImage: 'Add image',
    fPrimary: 'Primary',
    fMakePrimary: 'Make primary',
    fRemove: 'Remove',
    fPriceB2c: 'B2C price (manual)',
    fPriceB2b: 'B2B price (manual)',
    fRrp: 'Supplier RRP',
    fMarkupB2c: 'B2C markup override, %',
    fMarkupB2b: 'B2B markup override, %',
    fSiteAction: 'Visibility override',
    siteAction: { auto: 'Automatic', show: 'Show', preorder: 'Pre-order', hide: 'Hide' },
    calc: 'calculated {{value}}',
    siteJson: 'JSON sent to the site',
    detailDescription: 'Description',
    detailSpecs: 'Specifications',
    detailDelivery: 'Delivery',
    deliveryText: 'Pickup by Treejar from the supplier warehouse, delivery across the UAE within {{min}}–{{max}} working days after order confirmation.',
    warrantyBadge: '{{months}}-month warranty',
    deliveryBadge: '{{min}}–{{max}} days',
    related: 'Related products',
    status: {
      none: 'Not prepared',
      draft: 'Draft',
      approved: 'Approved by supplier',
      queued: 'Sending…',
      live: 'Live on site',
      failed: 'Rejected by site',
      archived: 'Archived',
    },
    problems: {
      contract_required: 'Signed contract required',
      approval_required: 'Supplier approval required',
      excluded_by_partner: 'Excluded by supplier',
      category_missing: 'Site category not mapped',
      image_missing: 'No image',
      name_missing: 'No name',
      price_missing: 'Price missing',
      price_below_min: 'Price below minimum resale',
      discontinued: 'Discontinued',
    },
    apprTitle: 'Supplier approval for listing',
    apprDesc: 'The supplier reviews the cards, unticks what must not be listed and confirms the rest. The signature, name and time are stored; the owner receives the list by e-mail.',
    apprExclude: 'Do not list',
    apprMethod: 'Confirmation method',
    methods: { tablet_signature: 'Signature on tablet', sms_code: 'Code by SMS / WhatsApp', portal: 'Confirmation in portal', scan: 'Signed scan' },
    apprName: 'Approved by (name)',
    apprContact: 'Contact (e-mail or phone)',
    apprNotes: 'Notes',
    apprSign: 'Supplier signs here',
    apprClear: 'Clear',
    apprSubmit: 'Record approval',
    apprSubmitting: 'Recording…',
    apprDone: 'Approval recorded: {{count}} items',
    apprHistory: 'Previous approvals',
    apprNone: 'No approvals yet.',
    apprRow: '{{name}} · {{method}} · {{count}} items · excluded {{excluded}}',
    apprNeedProducts: 'Publish the price list first: there are no products to approve.',
    apprSelected: '{{count}} to list, {{excluded}} excluded',
    ctrTitle: 'Partner agreement',
    ctrDesc: 'Generated from the Treejar template with the partner\'s terms. Without a signed, valid agreement nothing is published, reserved or ordered.',
    ctrTemplate: 'Template',
    ctrStart: 'Valid from',
    ctrEnd: 'Valid to',
    ctrTerms: 'Terms',
    ctrCreate: 'Create agreement',
    ctrCreating: 'Creating…',
    ctrCreated: 'Agreement {{number}} created',
    ctrPreview: 'Preview',
    ctrPdf: 'Download PDF',
    ctrSend: 'Send to partner',
    ctrSent: 'Sent to {{email}}',
    ctrSign: 'Sign',
    ctrSignerName: 'Signer name (partner side)',
    ctrSignTablet: 'Signature on tablet',
    ctrSignScan: 'Upload signed scan',
    ctrScanFile: 'Signed scan (PDF/JPG)',
    ctrSigned: 'Signed by {{name}}',
    ctrHistory: 'Versions',
    ctrNone: 'No agreement yet.',
    ctrNoTemplates: 'No active contract template. Create one in Settings.',
    ctrStatus: { Draft: 'Draft', Sent: 'Sent', Signed: 'Signed', Expired: 'Expired' },
    ctrSignDone: 'Agreement signed. Partner is now Active.',
    sendTitle: 'Send prepared listings to treejartrading.ae',
    sendDesc: 'Only the administrator sends. Pre-checks: signed contract, supplier approval, mapped category, primary image, both prices, texts. Nothing is sent until every selected SKU passes.',
    sendSelectReady: 'Select all ready',
    sendSelected: '{{count}} selected',
    sendButton: 'Send to site',
    sendForce: 'Send despite warnings',
    sending: 'Sending…',
    sendDone: 'Sent: {{ok}} accepted, {{failed}} rejected',
    sendNotAdmin: 'Only an administrator can send listings to the site.',
    sendNotConfigured: 'Site API is not configured: set the URL in Settings → Site integration and SITE_API_TOKEN on the server.',
    sendBlocked: 'Blocked: {{problems}}',
    openOnSite: 'Open on site',
    archive: 'Archive on site',
    archiveReason: 'Reason',
    archived: '{{sku}} archived',
    reasons: { withdrawn_by_partner: 'Withdrawn by supplier', contract_ended: 'Contract ended', replaced: 'Replaced', admin: 'Administrator decision' },
    pushAvailability: 'Push stock now',
    pushDone: 'Availability pushed: {{status}}',
    pubTitle: 'Publications',
    pubNone: 'No publications yet.',
    pubRow: '{{kind}} · {{status}} · {{ok}} ok / {{failed}} failed',
    pubKind: { listings: 'Listings', availability: 'Availability', archive: 'Archive' },
    pubStatus: { queued: 'Queued', sent: 'Sent', acknowledged: 'Accepted', partial: 'Partially accepted', failed: 'Failed' },
    summaryContract: 'Contract',
    summaryApproval: 'Approval',
    summaryReady: 'Ready to send',
    summaryLive: 'Live on site',
    yes: 'yes',
    no: 'no',
    none: 'none',
    error: 'Error: {{code}}',
  },
  siteint: {
    tab: 'Site integration',
    title: 'treejartrading.ae integration',
    desc: 'Push of approved listings and daily availability to the site, pull API keys for the site, webhooks, category mapping. Contract: docs/SITE-API.md.',
    apiUrl: 'Site API base URL',
    apiUrlHint: 'For example https://treejartrading.ae/api/internal/partner. The push token SITE_API_TOKEN lives in the server .env.',
    mediaBase: 'Public media base (image URLs)',
    tokenOk: 'Push token configured on server',
    tokenMissing: 'SITE_API_TOKEN is not set on the server',
    scheduler: 'Scheduler (06:00 Dubai snapshot and webhooks)',
    on: 'on',
    off: 'off',
    save: 'Save',
    saved: 'Saved',
    test: 'Test connection',
    testResult: 'Site answered {{status}}',
    channels: 'Channel pricing and visibility defaults',
    markupB2b: 'Default B2B markup, %',
    lowStock: 'Low stock threshold, pcs',
    deliveryDays: 'Delivery days on site (min–max)',
    hideAfter: 'Hide after data age, days',
    keys: 'API keys for the site (pull)',
    keysDesc: 'The site uses a key to read listings, availability, daily snapshots and events. The token is shown once.',
    keyName: 'Key name',
    createKey: 'Create key',
    keyCreated: 'Copy the token now, it will not be shown again:',
    copy: 'Copy',
    copied: 'Copied',
    revoke: 'Revoke',
    revoked: 'Key revoked',
    noKeys: 'No keys yet.',
    scope: {
      listings_read: 'read listings',
      stock_read: 'read stock',
      events_read: 'read events',
      listings_write: 'edit previews and photos',
      sales_write: 'report sales',
      sales_read: 'read sales',
    },
    lastUsed: 'last used {{date}}',
    neverUsed: 'never used',
    webhooks: 'Webhooks',
    webhooksDesc: 'The site subscribes itself through POST /site/v1/webhooks. Deliveries are signed with HMAC-SHA256.',
    noWebhooks: 'No webhooks.',
    pending: '{{count}} events pending delivery',
    map: 'Category map: hub type → site category',
    mapDesc: 'Primary slug of treejartrading.ae (chairs, executive-chair, desks-tables, sofas, storage …) and additional categories, comma separated.',
    mapType: 'Hub type',
    mapPrimary: 'Primary slug',
    mapAdditional: 'Additional',
    mapSave: 'Save map',
    mapSaved: 'Category map saved',
    snapshot: 'Build daily snapshot now',
    snapshotDone: 'Snapshot for {{date}}: {{items}} items',
    lastSnapshot: 'Last snapshot: {{date}}, {{items}} items',
    noSnapshot: 'No snapshot yet.',
    publications: 'Recent publications',
    delete: 'Delete',
  },
  ord: {
    description: 'Purchase orders are read from Zoho Books for partners matched by vendor. Zoho stays the source of truth; the hub keeps a read-only copy and refreshes it daily.',
    syncNow: 'Load from Zoho',
    syncStarted: 'Loading purchase orders from Zoho in the background…',
    syncRunning: 'Loading from Zoho…',
    lastSync: 'Zoho: {{date}} · imported {{imported}}, skipped {{skipped}}',
    zohoNotConfigured: 'Zoho keys (client id, secret, refresh token) are not set on the server.',
    unmatched: 'Vendors without a partner in the hub',
    search: 'Search by number, partner, reference',
    colReference: 'Reference',
    colTotal: 'Total incl. VAT',
    colOrdered: 'Ordered',
    colExpected: 'Expected',
    colReceived: 'Received',
    emptyAll: 'No purchase orders yet. Load them from Zoho.',
    footerZoho: 'Source: Zoho Books purchase orders, partners matched by vendor name or Zoho vendor id',
    openZoho: 'Open in Zoho',
    ordered: 'ordered',
    expected: 'expected',
    vat: 'VAT',
    timelineReceived: 'Received / picked up',
    timelineBilled: 'Billed',
    billed: 'billed',
    syncedAt: 'Synced from Zoho {{date}}',
    billedStatus: 'Billing (Zoho)',
    receivedStatus: 'Receiving (Zoho)',
    paymentStatus: 'Payment status',
    noArrivals: 'No open deliveries in the next weeks.',
  },
  fbp: {
    eyebrow: 'Ideas and problems',
    title: 'Feedback',
    description: 'Everything reported through the «Idea / Problem» button. Admin approves an item and presses «Run fix»: the robot picks it up within 10 minutes, fixes, deploys and reports here.',
  },
  pc: {
    onboardingCount: 'onboarding: {{count}}',
    statStale: 'Stale price lists',
    staleHint: 'active suppliers without a price list for {{days}} days',
    colContract: 'Contract',
    footer: '{{shown}} of {{total}} suppliers',
    footerNote: 'Data from supplier cabinets and price list imports · prices excl. VAT',
    tabs: { overview: 'Overview', listings: 'Listings & prices', site: 'Website', lists: 'Price lists', terms: 'Terms & details', contract: 'Contract', orders: 'Orders (Zoho)' },
    openPreview: 'Card preview',
    openSite: 'Open website',
    websiteTitle: 'Supplier website',
    websiteSub: 'The catalogue address is stored in the cabinet and used in the contract and listing.',
    websiteSaved: 'Website address saved',
    websiteNote: 'The website is not parsed automatically. Products, prices and stock enter the hub from the supplier price list (PDF, Excel, CSV or photos) via «Import price list», and site cards are prepared on the «Preview» step.',
    markups: 'Markups',
    days: 'days',
    hours: 'h',
    readyTitle: 'Path to the site',
    readySub: 'Onboarding steps; click a step to open it.',
    filled: 'filled in',
    noTrn: 'no TRN or warehouse',
    readyOf: '{{ready}} of {{total}} ready · {{images}} with photos',
    liveOf: '{{live}} of {{total}} on site',
    siteNotConfigured: 'Site API address is not set: sending goes to the sandbox. Settings → Site integration.',
    statReady: 'Ready for site',
    statLive: 'On site',
    listingsSub: 'Cost from the price list, channel prices by markups B2C {{b2c}} % and B2B {{b2b}} % (orange — set manually).',
    colSku: 'SKU',
    colName: 'Site name',
    colCost: 'Cost, AED',
    colStock: 'Stock',
    colAvail: 'Availability',
    colListing: 'Listing',
    noName: 'no name',
    noListings: 'No items yet: upload a price list.',
    listingsFooter: '{{total}} items · {{ready}} ready · {{live}} on site',
    avail: { in_stock: 'In stock', low_stock: 'Low stock', out_of_stock: 'Out of stock', in_transit: 'In transit', discontinued: 'Discontinued' },
    websiteSub2: 'Catalogue address on the dealer website. The site scan collects product cards (photos, description, specs, site price) and links them to price list articles.',
    websiteNote2: 'Site photos and descriptions go into the card preview: automatically when a price list is published, or via «Pull into preview» for items already published. Only empty fields are filled; the site price becomes the recommended retail price (RRP).',
    scan: 'Scan website',
    rescan: 'Scan again',
    scanStarted: 'Website scan started — usually 1–3 minutes',
    scanRunning: 'Scanning…',
    urlRequired: 'Enter the website address',
    scanPages: 'Pages',
    scanProducts: 'Cards on site',
    scanMatched: 'Matched price list',
    scanApplied: 'In preview',
    scanStatus: { queued: 'Queued', running: 'Scanning', done: 'Done', failed: 'Failed' },
    lastScan: 'last scan: {{date}}',
    neverScanned: 'The website has not been scanned yet.',
    applyToPreview: 'Pull into preview',
    applyOverwrite: 'Replace photos from site',
    applyOverwriteHint: 'Replace all listing photos with site photos, including manually uploaded ones (descriptions fill empty fields only)',
    applyToPreviewHint: 'Site photos are used when the listing has none or only a PDF price-list thumbnail; descriptions and specs fill empty fields',
    applied: 'Site data pulled into {{count}} listings',
    appliedNone: 'Nothing to pull: no matched cards or fields already filled',
    openSiteTab: 'Cards from site ({{count}}) →',
    siteProductsTitle: 'Product cards from the supplier website',
    siteProductsSub: 'Click a match to set the article manually; an empty value clears the link.',
    siteFilter: { all: 'All', matched: 'Matched', unmatched: 'No article' },
    colSiteProduct: 'Product on site',
    colSitePrice: 'Site price',
    colSiteAvail: 'Availability',
    colMatched: 'Price list article',
    colApplied: 'Pulled',
    matchPlaceholder: 'article from price list',
    matchHint: 'Set the article manually',
    noMatch: 'not found',
    noSiteProducts: 'No cards yet — run the website scan.',
    pullSite: 'Pull from site',
    pullSiteHint: 'Photos, descriptions, specs and site price (RRP) from the scanned supplier website — into empty listing fields',
    readOnly: 'Terms are edited by the admin and the partner manager.',
    noOrders: 'No Zoho Books purchase orders for this supplier in the last 12 months.',
  },
  imd: {
    noImage: 'No picture found in the price list for this row',
    imageFromPdf: 'Cropped from the PDF price list by the article position; becomes the first listing photo after publishing.',
    imageHint: 'A photo can be added on the «Preview» step or pulled from the supplier website.',
    reviewedYes: 'Reviewed',
    markReviewed: 'Mark as reviewed',
    include: 'Include in publication',
    exclude: 'Exclude from publication',
    openSku: 'Open SKU in catalog',
    excluded: 'excluded',
    secPrices: 'Prices and surcharges',
    secStock: 'Stock and packing',
    secProduct: 'Product',
    secSecondPass: 'Second model pass (number check)',
    catalogPrice: 'Current catalog price',
    catalogStock: 'Current catalog stock',
    packingVariants: 'Packing variants',
    packing: 'Packing',
    spPrices: 'Prices on the page',
    versionHint: 'Import draft {{id}}. Values are edited directly in the table.',
    whyTitle: 'Why this row needs a manual check',
    why: { risk: 'Risk {{risk}} AED is not below the {{threshold}} AED threshold. Risk estimates the cost of a mistake: for a new item it is 25 % of the stock value ({{stock}} × {{price}} × 0.25); for a known item it is the price difference times quantity, or 25 % of the stock change value. The more money behind a row, the more a human confirmation matters.', flags: 'Checks triggered: {{flags}}.', low_confidence: 'Recognition confidence {{conf}} % is below 85 %.' },
    whyAction: 'Compare the price and stock with the price list (page shown in the header), correct the values in the table if needed, and press «Mark as reviewed».',
    attach: 'Pictures from PDF: {{count}} of {{total}}',
    attachHint: 'Re-crop item pictures from the PDF price list',
  },
  portalContract: {
    none: 'No agreement has been issued yet. Your Treejar manager will send it after the visit.',
    pdf: 'Download PDF',
    signedBy: 'Signed by {{name}} on {{date}}',
    valid: 'Valid {{from}} – {{to}}',
  },
};
